import type { Animal } from '@origami/shared'

export interface AnimalInfo {
  /** Kanji character for the class (used as a glyph on chips). */
  kanji: string
  /** English name. */
  en: string
  /** CSS variable reference for chip background fill. */
  bg: string
  /** CSS variable reference for the kanji glyph "ink" color. */
  accent: string
}

/**
 * Per-animal display metadata. Colors picked from the accent palette
 * to be visually distinct from the 5 element colors (--el-fire / water
 * / wind / wood / earth). Pairs with ELEMENT_INFO at the chip level —
 * elements use round pills with element bg; animals use square hanko
 * seals with these animal bg colors.
 */
export const ANIMAL_INFO: Record<Animal, AnimalInfo> = {
  bird:    { kanji: '鳥', en: 'Bird',    bg: 'var(--lavender)', accent: 'var(--lavender-deep)' },
  mammal:  { kanji: '獣', en: 'Mammal',  bg: 'var(--peach)',    accent: 'var(--sakura-deep)'   },
  reptile: { kanji: '蛇', en: 'Reptile', bg: 'var(--sky)',      accent: 'var(--sky-deep)'      },
  fish:    { kanji: '魚', en: 'Fish',    bg: 'var(--sakura)',   accent: 'var(--sakura-deep)'   },
  insect:  { kanji: '虫', en: 'Insect',  bg: 'var(--mint)',     accent: 'var(--mint-deep)'     },
}
